// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/enum/v1/store_invoice_status.proto (package fingertip.common.enum.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum fingertip.common.enum.v1.StoreInvoiceStatus
 */
export const StoreInvoiceStatus = /*@__PURE__*/ proto3.makeEnum(
  "fingertip.common.enum.v1.StoreInvoiceStatus",
  [
    {no: 0, name: "STORE_INVOICE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 2, name: "STORE_INVOICE_STATUS_DRAFT", localName: "DRAFT"},
    {no: 1, name: "STORE_INVOICE_STATUS_PENDING", localName: "PENDING"},
    {no: 4, name: "STORE_INVOICE_STATUS_VOID", localName: "VOID"},
    {no: 5, name: "STORE_INVOICE_STATUS_PAID", localName: "PAID"},
    {no: 6, name: "STORE_INVOICE_STATUS_UNPAID", localName: "UNPAID"},
    {no: 7, name: "STORE_INVOICE_STATUS_REFUNDED", localName: "REFUNDED"},
    {no: 8, name: "STORE_INVOICE_STATUS_PROCESSING", localName: "PROCESSING"},
  ],
);

